// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Spinner_wrapper__1L8nk","spinner":"Spinner_spinner__1Nh-g","spin":"Spinner_spin__exvrK","small":"Spinner_small__3ye8G"};